/**
 * Approximate lat/lng for the Salento towns covered by our OMI dataset.
 * Coordinates come from Wikipedia/OSM (town hall / centro storico). Precision
 * to 3-4 decimals is enough since the markers are placed for visual clustering,
 * not for navigation.
 *
 * Keys must match the lowercase form used in `backend/sei/omi_data.py`.
 */
export const TOWN_COORDS = {
  // Lecce
  "lecce": [40.3528, 18.1741],
  "gallipoli": [40.0558, 17.9925],
  "otranto": [40.1481, 18.4910],
  "santa cesarea terme": [40.0381, 18.4598],
  "castro": [40.0064, 18.4326],
  "tricase": [39.9300, 18.3536],
  "santa maria di leuca": [39.7972, 18.3596],
  "porto cesareo": [40.2603, 17.8895],
  "nardò": [40.1789, 18.0331],
  "nardo": [40.1789, 18.0331],
  "galatina": [40.1718, 18.1697],
  "maglie": [40.1219, 18.3000],
  "copertino": [40.2700, 18.0497],
  "salve": [39.8597, 18.3017],
  "ugento": [39.9272, 18.1614],
  "racale": [39.9603, 18.0958],
  "casarano": [40.0167, 18.1672],
  "specchia": [39.9319, 18.3072],
  "alessano": [39.8908, 18.3303],
  "patù": [39.8333, 18.3531],
  "presicce": [39.8983, 18.2611],
  "presicce-acquarica": [39.8983, 18.2611],
  "acquarica del capo": [39.9100, 18.2783],
  "corigliano d'otranto": [40.1611, 18.2606],
  "melendugno": [40.2683, 18.3328],
  "torre dell'orso": [40.2750, 18.4242],
  "san foca": [40.3144, 18.3992],
  "roca": [40.2858, 18.4322],
  "supersano": [40.0233, 18.2453],
  "uggiano la chiesa": [40.0817, 18.4283],
  "alliste": [39.9492, 18.0814],
  "morciano di leuca": [39.8517, 18.3258],
  "monteroni di lecce": [40.3208, 18.0917],
  "vernole": [40.3372, 18.2786],
  "calimera": [40.2961, 18.2806],
  // Brindisi
  "brindisi": [40.6383, 17.9456],
  "ostuni": [40.7300, 17.5783],
  "carovigno": [40.7050, 17.6611],
  "ceglie messapica": [40.6481, 17.5167],
  "cisternino": [40.7411, 17.4239],
  "fasano": [40.8358, 17.3603],
  "francavilla fontana": [40.5333, 17.5833],
  "mesagne": [40.5586, 17.8061],
  "san vito dei normanni": [40.6536, 17.7064],
  "torre santa susanna": [40.4683, 17.7311],
  "oria": [40.4994, 17.6394],
  // Taranto
  "taranto": [40.4644, 17.2470],
  "martina franca": [40.7028, 17.3375],
  "manduria": [40.4019, 17.6328],
  "avetrana": [40.3514, 17.7311],
  "sava": [40.4036, 17.5586],
  "maruggio": [40.3175, 17.7686],
  "campomarino": [40.2917, 17.8000],
  "torricella": [40.3361, 17.7906],
  "pulsano": [40.3814, 17.3531],
  "leporano": [40.3814, 17.3253],
  "grottaglie": [40.5378, 17.4347],
  "massafra": [40.5894, 17.1158],
  "lizzano": [40.3911, 17.4475],
  "marina di lizzano": [40.3536, 17.4839],
};
